import React, { createContext, useContext, useEffect, useState } from 'react';
import { createCity, deleteCityApi, fetchCities, updateCityApi } from '../api/cityApi';
import { City } from '../types/city';



interface CityContextType {
    cities: City[];
    addCity: (city: City) => void;
    deleteCity: (id: string) => void;
    updateCity: (updatedCity: City) => void;
}

const CityContext = createContext<CityContextType | undefined>(undefined);

export const CityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [cities, setCities] = useState<City[]>([]);

    const listCities = async () => {
        fetchCities()
            .then((response) => {
                setCities(response);
            })
            .catch((error) => {
                console.error('Error fetching cities:', error);
            }
            );
    };

    const addCity = async (city: City) => {
        await createCity(city)
            .then((response) => {
                setCities(prev => [...prev, response]);
            })
            .catch((error) => {
                console.error('Error creating city:', error);
            }
            );
    };

    const deleteCity = async (id: string) => {
        try {
            await deleteCityApi(id);
            setCities(prev => prev.filter(city => city.id !== id));
        } catch (error) {
            console.error('Error deleting city:', error);
        }
    };

    const updateCity = async (updatedCity: City) => {
        try {
            if (!updatedCity.id) {
                console.error("City ID is missing");
                return;
            }
            const newCity = await updateCityApi(updatedCity, updatedCity.id);
            setCities(prev =>
                prev.map(city => (city.id === newCity.id ? newCity : city))
            );
        } catch (error) {
            console.error('Error updating city:', error);
        }
    };

    useEffect(() => {
        listCities();
    }, []);


    return (
        <CityContext.Provider value={{ cities, addCity, deleteCity, updateCity }}>
            {children}
        </CityContext.Provider>
    );
};

export const useCity = () => {
    const context = useContext(CityContext);
    if (!context) throw new Error('useCity must be used within CityProvider');
    return context;
};
